// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '0.1.1';
export const APP_NAME = 'bitf-angular-boilerplate';
export const FILE_HASH = '1695639297169';
export const BUILD_DATE = '2023-09-25T10:54:57.169Z';
/* tslint:enable */
